<template>
  <div class="blackout">
    <div class="row mx-auto container-start">
      <div
        class="col-0 col-xs-10 col-sm-7 col-md-6 col-lg-5 mx-auto pb-4 align-self-center bg-white rounded shadow"
      >
        <div class="row mb-3 py-2 py-md-3 bg-info rounded-top">
          <div class="title-start h4 text-white mx-auto">Выберите аватар и ник</div>
        </div>
        <div class="row col-12 mx-auto align-items-center justify-content-center">
          <b-button @click="PrevAvatar" variant="info" class="btn-arrow">
            <b-icon-chevron-compact-left />
          </b-button>
          <Avatar
            @ultra_click="avatar = $event"
            class="mx-1"
            :width_img="80"
            :height_img="80"
            :id_avatar="avatar"
          />
          <b-button @click="NextAvatar" variant="info" class="btn-arrow">
            <b-icon-chevron-compact-right />
          </b-button>
          <div class="col-9 col-sm-7 m-3">
            <b-input :class="{'border-danger': create_disabled}" v-model.trim="name"></b-input>
            <div class="text-danger mb-n4" v-show="create_disabled">{{valid_name_msg}}</div>
          </div>
        </div>
        <div class="row mt-3 mx-auto justify-content-center">
          <b-button
            @click="ShowTab('join')"
            :disabled="create_disabled"
            variant="info"
            class="m-2"
          >Присоединиться</b-button>
          <b-button
            @click="ShowTab('create')"
            :disabled="create_disabled"
            variant="info"
            class="m-2"
          >Создать комнату</b-button>
          <div
            v-if="info_state === 'description'"
            class="col-10 pt-3 text-center"
          >«Крокодил» - Многопользовательская игра, где игроки по очереди отгадывают слово по рисунку. Отгадывающие, пишут слово в чат, основываясь на рисунке художника, а художник старается изобразить это слово как можно более понятнее. Запрещено писать слово на холсте в роли художника. Можно использовать систему ребуса (к примеру, для сложных слов).</div>
          <b-input-group
            v-show="info_state === 'join'"
            class="w-75 mt-3 justify-content-between rounded border align-items-center"
          >
            <b-form-text class="ml-2"></b-form-text>
            <b-form-text>
              <b>Комнат - {{rooms.length}}</b>
            </b-form-text>
            <b-form-text>
              <b>Людей - {{allUsersInRomms}}</b>
            </b-form-text>
            <b-input-group-append>
              <b-button
                :disabled="update_list_disabled"
                @click="UpdateListRoom"
                size="sm"
                variant="info"
              >
                <b-icon-arrow-clockwise />
              </b-button>
            </b-input-group-append>
          </b-input-group>
          <h1
            v-show="rooms.length == 0 && info_state === 'join'"
            class="w-75 p-3 my-1 rounded border text-center text-muted"
          >:c</h1>
          <div v-if="info_state === 'join'" class="list-h overflow-auto col-10 pt-3 text-center">
            <b-button
              :disabled="locker_request_join"
              variant="info"
              v-for="(room, index) in roomsSorted"
              @click="SelectToJoinRoom(index)"
              :key="room.id"
              class="col-12 col-sm-12 col-lg-10 p-0 my-1 rounded border-0 text-white"
            >
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center col-10">
                  <div class="text-truncate">{{room.data.name}}</div>
                  <b-icon-lock-fill v-show="room.data.pass" variant="warning" />
                </div>
                <div class="d-flex align-items-center col-2">
                  {{room.data.count}}
                  <b-icon-person-fill variant="warning" />
                </div>
              </div>
              <div v-show="index_show_pass == index">
                <form
                  class="d-flex col-12 mb-1 align-items-center justify-content-center input-group"
                >
                  <b-form-input
                    @click.stop
                    type="password"
                    placeholder="пароль"
                    autocomplete="off"
                    v-model="room.passInput"
                    size="sm"
                    :class="[{'alert-danger': index_invalid_pass == index},'col-6']"
                  ></b-form-input>
                  <div class="input-group-append">
                    <b-button
                      :disabled="locker_request_join"
                      @click.stop="JoinRoom(index)"
                      size="sm"
                      variant="warning"
                      class="text-secondary"
                    >Войти</b-button>
                  </div>
                </form>
              </div>
            </b-button>
          </div>
          <form v-if="info_state === 'create'" class="col-9 pt-3 text-center">
            <b-input
              @blur="ValidNameRoom"
              v-model="nameRoom"
              size="sm"
              placeholder="Имя комнаты"
              :class="[name_room_disabled_offline || name_room_disabled_online ? 'border-danger':'border-success' ,'mb-0']"
            ></b-input>
            <div
              :class="[name_room_disabled_offline || name_room_disabled_online ? 'alert-danger' : 'alert-success','p-0','mb-2', 'alert']"
              role="alert"
            >{{valid_nameRoom_msg}}</div>
            <b-input
              v-model="password"
              :disabled="!password_state"
              type="password"
              size="sm"
              placeholder="Пароль"
              autocomplete="off"
              :class="[{'border-danger': pass_room_disabled && password_state} ,'mb-0']"
            ></b-input>
            <div
              v-show="pass_room_disabled && password_state"
              class="alert-danger p-0 mb-2 alert"
              role="alert"
            >{{valid_passRoom_msg}}</div>
            <b-checkbox v-model="password_state" class="mb-1">С паролем</b-checkbox>
            <b-button
              :disabled="(password_state && pass_room_disabled) || name_room_disabled_offline || name_room_disabled_online || locker_request_join"
              @click="CreateRoom"
              variant="warning"
              size="sm"
              class
            >Готово</b-button>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Avatar from "@/components/Avatar";
export default {
  components: {
    Avatar
  },
  props: {
    // rooms = { name: "name_room_text", pass: true, creator: "ID_user" count: 2 }
    rooms: { type: Array, default: [] }
  },
  data() {
    return {
      // блокировка обработки запроса присоединения
      locker_request_join: false,
      // индекс не прошедшего проверку пароля элемента
      index_invalid_pass: -1,
      // индекс элемента для показа пароля
      index_show_pass: -1,
      // состояние панели
      info_state: "description",
      // аватар
      avatar: 0,
      // имя
      name: "",
      // имя комнаты
      nameRoom: "",
      // пароль
      password: "",
      // с паролем/без
      password_state: false,
      // сообщение при валидации имени
      valid_name_msg: "",
      // валидность имени комнаты в целом при проверке онлайн)
      name_room_disabled_online: false,
      // сообщение при валидации имени комнаты
      valid_nameRoom_msg: "Имя комнаты слишком короткое",
      // сообщение при валидации пароля комнаты
      valid_passRoom_msg: "Пароль менее 3 символов",
      // состояние кнопки UpdateList
      update_list_disabled: false
    };
  },
  computed: {
    // кол-во всех пользователей во всех комнатах вместе
    allUsersInRomms() {
      let count = 0;
      this.rooms.forEach(el => {
        count += el.count;
      });
      return count;
    },
    // Обертка над обьектами комнат для хранения состояния введенного пароля
    roomsStated() {
      return this.rooms.map(value => {
        return {
          passInput: "",
          data: value
        };
      });
    },
    // сортировка комнат
    roomsSorted() {
      return this.roomsStated.sort((a, b) => {
        if (a.data.count > b.data.count) return -1;
        if (a.data.count < b.data.count) return 1;
        return 0;
      });
    },
    // триггер выключения при некорректном вводе имени комнаты без онлайн проверки
    name_room_disabled_offline() {
      let result = this.nameRoom.length < 3;
      this.valid_nameRoom_msg = result ? "Имя комнаты слишком короткое" : "ок";
      return result;
    },
    // триггер выключения при некорректном вводе пароле комнаты
    pass_room_disabled() {
      let result = this.password.length < 3;
      if (result) this.valid_passRoom_msg = "Пароль менее 3 символов";
      return result;
    },
    // триггер выключения при некорректном вводе ника
    create_disabled() {
      let result = this.name.length < 3;
      if (!result) this.valid_name_msg = "Ник слишком короткий";
      return result;
    }
  },
  mounted() {
    if (localStorage.name) {
      this.name = localStorage.name;
    }
    if (localStorage.avatar) {
      this.avatar = parseInt(localStorage.avatar, 10);
    }
  },
  watch: {
    name(newName) {
      localStorage.name = newName.trim();
    },
    avatar(newName) {
      localStorage.avatar = newName;
    }
  },
  methods: {
    /**
     * Обновление списка комнат
     */
    UpdateListRoom() {
      this.update_list_disabled = true;
      this.$emit("refresh-rooms", () =>
        setTimeout(() => (this.update_list_disabled = false), 3000)
      );
    },

    /**
     * онлайн проверка имени
     */
    ValidNameRoom() {
      if (this.name_room_disabled_offline) return;

      this.name_room_disabled_online = true;
      this.valid_nameRoom_msg = "проверяю...";
      this.$emit("check_name_room", {
        nameRoom: this.nameRoom,
        valid: () => {
          this.name_room_disabled_online = false;
          this.valid_nameRoom_msg = "ок";
        },
        invalid: msg => {
          this.name_room_disabled_online = true;
          this.valid_nameRoom_msg = msg;
        }
      });
    },

    /**
     * Конечный автомат переключения состояния информации
     * @param {String} nameCategory имя категории которую нужно отобразить:
     * "join", "create"
     */
    ShowTab(nameCategory) {
      if (this.info_state == nameCategory) {
        this.info_state = "description";
      } else {
        if (nameCategory == "join") this.UpdateListRoom();
        this.info_state = nameCategory;
      }
    },

    /**
     * Обработчик кнопки комнаты в списке комнат.
     * Раскрывает/скрывает поле ввода пароля если он есть,
     * если нету - подключается к комнате.
     * @param {Number} index индекс комнаты в сортированном масиве комнат "this.roomsSorted"
     */
    SelectToJoinRoom(index) {
      if (this.index_show_pass == index) this.index_show_pass = -1;
      else if (this.roomsSorted[index].data.pass) this.index_show_pass = index;
      else this.JoinRoom(index);
    },

    /**
     * Обработчик кнопки "Войти" в списке комнат.
     * Пытается присоединиться к указанной в "index" комнате.
     * @param {Number} index индекс комнаты в сортированном масиве комнат "this.roomsSorted"
     */
    JoinRoom(index) {
      if (!this.create_disabled && !this.locker_request_join) {
        this.locker_request_join = true;
        this.index_invalid_pass == -1;

        let nameRoom = this.roomsSorted[index].data.name;
        let password = this.roomsSorted[index].passInput;
        this.$emit("join_room", {
          name: this.name,
          avatar: this.avatar,
          nameRoom: nameRoom,
          password: password,
          invalid: () => {
            this.index_invalid_pass = index;
            setTimeout(()=> this.locker_request_join = false, 1000);
          },
          valid: () => {
            this.index_invalid_pass = -1;
            setTimeout(()=> this.locker_request_join = false, 1000);
          }
        });
      }
    },

    /**
     * Обработчик кнопки "Готово" в разделе "Создать комнату"
     */
    CreateRoom() {
      if (!this.create_disabled && !this.locker_request_join) {
        this.locker_request_join = true;
        this.$emit("create_room", {
          name: this.name,
          avatar: this.avatar,
          nameRoom: this.nameRoom,
          password: this.password_state ? this.password : "",
          invalid: () => {
            setTimeout(()=> this.locker_request_join = false, 1000);
          },
          valid: () => {
            setTimeout(()=> this.locker_request_join = false, 1000);
          }
        });
      }
    },

    /**
     * Обработчик кнопки сменить аватар ">"
     */
    NextAvatar() {
      this.avatar++;
      if (this.avatar > 8) this.avatar = 0;
    },

    /**
     * Обработчик кнопки сменить аватар "<"
     */
    PrevAvatar() {
      this.avatar--;
      if (this.avatar < 0) this.avatar = 8;
    }
  }
};
</script>

<style scoped>
.list-h {
  max-height: 15rem;
}
.btn-arrow {
  font-size: 1.48rem;
  vertical-align: center;
  padding: 0;
  border-radius: 50%;
  width: 35px;
  height: 35px;
}
.title-start {
  font-weight: 700;
  font-size: 2rem;
}
.container-start {
  z-index: 51;
  position: absolute;
  width: 100%;
  height: 100%;
}
.blackout {
  z-index: 50;
  position: absolute;
  width: 100%;
  height: 100%;
  background: #00000080;
}
</style>